import { useState } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import {
  formatTaxSummaryAmount,
  parseTaxSummaryAmount,
  TAX_SUMMARY_AMOUNT_CELL_CLASS,
  TAX_SUMMARY_AMOUNT_FIELD_CLASS,
} from "@/lib/taxSummaryWorkbookConstants";

export default function TaxSummaryAmountInput({
  value = "",
  onChange,
  editable = true,
  amountMode = "money",
  variant = "cell",
  className = "",
  onFocus,
  onBlur,
  title,
  "data-testid": dataTestId,
  ...rest
}) {
  const [focused, setFocused] = useState(false);
  const showFormatted = !focused || !editable;
  const isField = variant === "field";
  const baseClass = isField ? TAX_SUMMARY_AMOUNT_FIELD_CLASS : TAX_SUMMARY_AMOUNT_CELL_CLASS;
  const displayValue = showFormatted
    ? (value === "" || value == null ? "" : formatTaxSummaryAmount(value, amountMode))
    : String(value ?? "");

  if (!editable && showFormatted) {
    return (
      <div
        className={cn(
          baseClass,
          "flex items-center",
          isField ? "justify-start" : "justify-end bg-transparent",
          className,
        )}
        title={title}
        data-testid={dataTestId}
      >
        {displayValue || "\u00a0"}
      </div>
    );
  }

  return (
    <Input
      {...rest}
      value={displayValue}
      readOnly={!editable}
      inputMode="decimal"
      title={title}
      data-testid={dataTestId}
      onChange={(e) => {
        if (!editable || !onChange) return;
        onChange(parseTaxSummaryAmount(e.target.value, { partial: true, amountMode }));
      }}
      onFocus={(e) => {
        if (editable) setFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        if (editable && onChange) {
          onChange(parseTaxSummaryAmount(e.target.value, { amountMode }));
        }
        onBlur?.(e);
      }}
      className={cn(baseClass, className)}
    />
  );
}
